import React from "react";
import type { XY } from "../../../lib/geo/types";

type Props = {
  width: number;
  height: number;
  partitionMode: boolean;
  onPointerDown: (e: React.PointerEvent<SVGSVGElement>) => void;
  onPointerMove: (e: React.PointerEvent<SVGSVGElement>) => void;
  onPointerUp: (e: React.PointerEvent<SVGSVGElement>) => void;
};

export default function DrawCaptureLayer({
  width,
  height,
  partitionMode,
  onPointerDown,
  onPointerMove,
  onPointerUp,
}: Props) {
  if (!partitionMode) return null;
  return (
    <svg
      width={width}
      height={height}
      style={{
        position: "absolute",
        inset: 0,
        zIndex: 3,
        background: "transparent",
        cursor: "crosshair",
        touchAction: "none",
      }}
      onPointerDown={onPointerDown}
      onPointerMove={onPointerMove}
      onPointerUp={onPointerUp}
    />
  );
}
